import { Outlet } from "react-router-dom"
import { BottomGNB } from "@/components/BottomGNB"

import "@/styles/Layout.css"

export const Layout = () => {
  return (
    <div className="app-container">
      <div className="app-layout">
        <main className="main-content">
          <Outlet />
        </main>

        {/* 하단 GNB */}
        <BottomGNB />
      </div>
    </div>
  )
}
